module.exports = __webpack_public_path__ + "img/swiss-medical.e05c7483.png";